import { DecimalPipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { round } from 'lodash';

@Component({
  selector: 'app-unit-cell',
  imports: [TranslatePipe, DecimalPipe],
  templateUrl: './unit-cell.component.html',
  styleUrl: './unit-cell.component.scss',
})
export class UnitCellComponent {
  public readonly value = input.required<number | null>();
  public readonly unit = input.required<string | null>();
  public readonly decimalPlaces = input(0);

  protected decimalValue = computed(() =>
    this.value()
      ? round(this.value()! / 10 ** this.decimalPlaces(), this.decimalPlaces())
      : null,
  );
  protected pipeFormat = computed(() => `1.0-${this.decimalPlaces()}`);
}
